import { render, staticRenderFns } from "./Required.vue?vue&type=template&id=4ace9272"
import script from "./Required.vue?vue&type=script&lang=js"
export * from "./Required.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports